export enum OPERATE_TYPE_ENUM {
  NEW = '1',
  UPDATE = '2',
  DELETE = '3',
}
export const OPERATE_TYPE_LIST = [
  { value: OPERATE_TYPE_ENUM.NEW, label: '新建' },
  { value: OPERATE_TYPE_ENUM.UPDATE, label: '修改' },
  { value: OPERATE_TYPE_ENUM.DELETE, label: '删除' },
];

export enum DATA_TYPE_ENUM {
  STRING = '1',
  HASH = '2',
  SET = '3',
  ZSET = '4',
  LIST = '5',
}
export const DATA_TYPE_LIST = [
  { value: DATA_TYPE_ENUM.STRING, label: 'string' },
  { value: DATA_TYPE_ENUM.HASH, label: 'hash' },
  { value: DATA_TYPE_ENUM.SET, label: 'set' },
  { value: DATA_TYPE_ENUM.ZSET, label: 'zset' },
  { value: DATA_TYPE_ENUM.LIST, label: 'list' },
];
